export const SYSTEM_JOB_STATUS_BADGE = {
  SUCCESS: { text: 'Succeeded', color: 'success' },
  RUNNING: { text: 'Running', color: 'info' },
  FAILED: { text: 'Failed', color: 'danger' },
  PENDING_ASSET_REPORT: { text: 'Pending Asset Report', color: 'warning' },
  QUEUE: { text: 'In Queue', color: 'warning' },
};
